import { assertNever } from "../../../util/assertNever";
import { BooleanColumnOperators, CommonColumnOperators } from "../enum.filterOperators";
import { BooleanFilterType, GenericTableFilterType } from "../type.genericTableQuery";
import type { FilterMapper } from "./interface.filterMapper";

export class BooleanFilterMapper implements FilterMapper {
  toQuery({ filter }: BooleanFilterType): undefined | string {
    const option = filter.option;
    if (option === BooleanColumnOperators.BOOLEAN) {
      return `${BooleanColumnOperators.BOOLEAN}$-$${filter.value}`;
    } else if (option === CommonColumnOperators.VALUE_EXISTS) {
      const missingValue = filter.value;
      return `${CommonColumnOperators.VALUE_EXISTS}$-$${missingValue}`;
    }
    assertNever(option);
  }

  fromQuery(value: string): BooleanFilterType {
    const [columnOperator, filterValue] = value.split("$-$");
    const option = this.getBooleanColumnOperator(columnOperator);

    switch (option) {
      case BooleanColumnOperators.BOOLEAN:
        return {
          type: GenericTableFilterType.BOOLEAN,
          filter: {
            option: BooleanColumnOperators.BOOLEAN,
            value: filterValue === "true",
          },
        };
      case CommonColumnOperators.VALUE_EXISTS:
        return {
          type: GenericTableFilterType.BOOLEAN,
          filter: {
            option: CommonColumnOperators.VALUE_EXISTS,
            value: filterValue === "true",
          },
        };
      default:
        assertNever(option);
    }
  }

  private getBooleanColumnOperator(columnOperator: string): BooleanColumnOperators | CommonColumnOperators {
    const allOptions = [...Object.values(BooleanColumnOperators), ...Object.values(CommonColumnOperators)];
    if (allOptions.includes(columnOperator as BooleanColumnOperators | CommonColumnOperators)) {
      return columnOperator as BooleanColumnOperators | CommonColumnOperators;
    }
    throw new Error(`Invalid boolean filter option: ${columnOperator}`);
  }
}
